/** Three compact numeric cards: distance, average pace, rest. */
import { store } from '../state/store'
import { formatDistance, formatDuration, formatPace } from '../analytics/format'

function Card({
  label,
  color,
  value,
  unit,
  trend,
}: {
  label: string
  color: string
  value: string
  unit?: string
  trend: string
}) {
  return (
    <div class="card stat-card">
      <div class="label" style={`color:${color}`}>
        {label}
      </div>
      <div class="value">
        <b>{value}</b>
        {unit ? <small>{unit}</small> : null}
      </div>
      <div class="trend">{trend}</div>
    </div>
  )
}

export function StatCards() {
  const s = store.stats.value
  if (!s) return null

  const swimSets = s.stints.filter((st) => !st.isRest)
  const bestPace = swimSets.length
    ? Math.min(...swimSets.map((st) => st.paceSecondsPer100))
    : Infinity
  const restCount = s.rests.length
  const avgRestS = restCount ? Math.round(s.restMs / restCount / 1000) : 0
  const distanceParts = formatDistance(s.distanceM, s.unit).split(' ')

  return (
    <div class="stat-grid">
      <Card
        label="Distance"
        color="#30b0c7"
        value={distanceParts[0]!}
        unit={distanceParts[1] ?? s.unit}
        trend={`${swimSets.length} sets`}
      />
      <Card
        label="Average pace"
        color="#ff9500"
        value={formatPace(s.movingPaceSecondsPer100)}
        unit={`/100 ${s.unit}`}
        trend={`best ${formatPace(bestPace)}`}
      />
      <Card
        label="Rest"
        color="#8e8e93"
        value={formatDuration(s.restMs)}
        trend={restCount ? `${restCount} breaks · avg ${avgRestS}s` : 'no rests'}
      />
    </div>
  )
}
